import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom';

const CourseMaterials = () => {
    const [course, setCourse] = useState(null);
    const locationData = useLocation();

    useEffect(() => {
        if (locationData.state) {
            setCourse(locationData.state.course);
        }
    }, [course])

    if (!locationData.state) return <div className="text-center text-xl mt-8">Invalid page!</div>
    if (!course) return <div className="text-center text-xl mt-8">Loading...</div>
    return (
        <section id="courseMaterials" className="font-body">
            <div className="container px-5 py-10 mx-auto text-center lg:px-40">
                <div className="flex flex-col w-full mb-10">
                    <h1 className="sm:text-4xl text-3xl font-medium font-title mb-4">
                        {course.crn}: {course.title}
                    </h1>
                    <p className="text-md leading-relaxed tracking-wide">
                        Course Materials
                    </p>
                    <p className="text-md hover:text-highlight underline">
                        <Link
                            to={{
                                pathname: `/courseInfo`,
                                state: { course }
                            }}>
                            Back to Course Home
                        </Link>
                    </p>
                </div>
                <div className="text-left mb-20 font-body">
                    <section id="notes" className="mb-10">
                        <p className="font-bold font-title text-3xl mb-4">
                            Notes
                        </p>
                        <ul className="list-disc list-inside">
                            {course.materials.notes.map((note, index) => {
                                return (
                                    <li key={index} className="ml-10">
                                        <a
                                            className="mt-2 hover:text-highlight text-lg underline"
                                            href={note.link}
                                            target="_blank"
                                            title={note.name}> {note.name}
                                        </a>
                                    </li>
                                );
                            })}
                        </ul>
                    </section>
                    <section id="quizzes" className="mb-10">
                        <p className="font-bold font-title text-3xl mb-4">
                            Quizzes/Homework
                        </p>
                        <ul className="list-disc list-inside">
                            {course.materials.quizzes.map((quiz, index) => {
                                return (
                                    <li key={quiz} className="ml-10">
                                        <a
                                            className="mt-2 hover:text-highlight text-lg underline"
                                            href={quiz.link}
                                            target="_blank"
                                            title={quiz.name}> {quiz.name}
                                        </a>
                                    </li>
                                );
                            })}
                        </ul>
                    </section>
                    <section id="exams" className="mb-10">
                        <p className="font-bold font-title text-3xl mb-4">
                            Exams
                        </p>
                        <ul className="list-disc list-inside">
                            {course.materials.exam.map((exam, index) => {
                                return (
                                    <li key={index} className="ml-10">
                                        <a
                                            className="mt-2 hover:text-highlight text-lg underline"
                                            href={exam.link}
                                            target="_blank"
                                            title={exam.name}> {exam.name}
                                        </a>
                                    </li>
                                );
                            })}
                        </ul>
                    </section>
                </div>
            </div>
        </section >
    );
}
export default CourseMaterials;


// WEBPACK FOOTER //
// ./src/components/CourseMaterials.jsx